import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MergeCellsOutlinedSvg from "@ant-design/icons-svg/es/asn/MergeCellsOutlined";
import AntdIcon from "../components/AntdIcon";
var MergeCellsOutlined = function MergeCellsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MergeCellsOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MergeCellsOutlined.displayName = 'MergeCellsOutlined';
}
export default /*#__PURE__*/React.forwardRef(MergeCellsOutlined);